export const tourGuideSteps = [
  {
    selector: "#mc-server-info-filter",
    content:
      "Use these filters to expand or narrow the amount of data that is returned in the data grid below.",
  },
  {
    selector: "#mc-server-info-data-grid",
    content:
      "This data grid contains one row of data per registered Mirth Connect server. In cases of clusters, the Client Environment Column will be the cluster name and the server name will be each unique node in the cluster. The Client Environment name is derived from the Mirth Connect setting called 'Environment Name'. If it was empty, a MCC random UUID will be created.",
  },
];
